module.exports = __webpack_public_path__ + "static/media/small-pickup_2x.e03e6d5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vehicles/small-pickup_2x.png
// module id = 652
// module chunks = 27